import { render, staticRenderFns } from "./img-radio.vue?vue&type=template&id=6463a712&"
import script from "./img-radio.vue?vue&type=script&lang=js&"
export * from "./img-radio.vue?vue&type=script&lang=js&"
import style0 from "./img-radio.vue?vue&type=style&index=0&id=6463a712&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports